module.exports = __webpack_public_path__ + "static/media/provider2.94b1fbb1.png";